import { summonBank } from './summonBank';

/**
 * **特殊召喚（軽い召喚バンク。少し派手）の組み立て**（Issue #573 v1。指示書 `../direction/spsummoning.md`）。
 * 通常召喚（`../effects/summoning.js`）と同じ組み立て（`./summonBank.js`）で、カードが出る瞬間だけ派手にする（`flashy`）。
 *
 * 状況（`plain` / `synchro` / `fusion` / `ritual` / `xyz` / `link`。`editorPorts/duelSituations/spsummoning.js`）ごとのファイル
 * `../effects/spsummoning_<variant>_effect.js` がこれを呼ぶ（状況の名前を渡す）。**今はどの状況も同じ見せ方**（素材の種類ごとの専用バンクは Issue #598〜#602）。
 */
export const spsummoningSpec = (situation) => summonBank({
  situation,
  label: '特殊召喚（軽い召喚バンク。回って飛び出し、輪と放射の線）',
  color: '#ff9a3d',
  tag: ['SPECIAL', 'SUMMON'],
  flashy: true,
});
